import store from "@/state/store";

export default [
  {
    path: "/",
    redirect: { name: "login" },
  },
  {
    path: "/configuration",
    meta: {
      authRequired: true,
    },
    name: "configuration",
    component: () => import("@/components/wizzard/index.vue"),
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    //component: () => import("./../components/dashboard/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      const data = localStorage.getItem("user");
      const user = JSON.parse(data);
      let configured = localStorage.getItem("configured");
      configured = JSON.parse(configured);
      let freePlan = localStorage.getItem("freePlan");

      // Si el usuario tiene cpnfiguracion de empresa
      if (configured == false && user.role == "Client") {
        if (!freePlan) {
          return next({ name: "configuration" });
        }
      }

      // Si el usuario es cliente y ya paso la hora de consulta a efisco
      if (configured == true && user.role === "Client") {
        let get_date_efisco = localStorage.getItem("get_date_efisco");
        if (get_date_efisco == 0) {
          if (!freePlan) {
            return next({ name: "MessageDateEfisco" });
          }
        }
      }

      if (user.is_active == 0) {
        next({ name: "DeactivateUser" });
      } else {
        if (user.role == "Administrator") {
          // Redirigir al componente de administrador
          next({ name: "DashboardAdmin" });
        } else if (user.role === "Client") {
          // Redirigir al componente de usuario
          next({ name: "DashboardCustomer" });
        } else if (user.role === "Contador") {
          // Redirigir al componente de usuario
          next({ name: "DashboardAccountant" });
        } else if (user.role === "Supplier") {
          next({ name: "taxShieldSupplerInvoices" });
        } else {
          next({ name: "DashboardGeneral" });
        }
      }
    },
  },
  {
    path: "/deactivate-user",
    name: "DeactivateUser",
    component: () => import("../layouts/deactivate.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/dashboard-customer",
    name: "DashboardCustomer",
    component: () => import("./../components/dashboard/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      console.log(from);
      if (from.name === "login") {
        // Asume que tu ruta de login se llama 'Login'
        to.meta.fromLogin = true;
      }
      next();
    },
  },
  {
    path: "/dashboard-admin",
    name: "DashboardAdmin",
    component: () => import("./../components/dashboardAdmin/index.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/login",
    name: "login",
    // component: () => import("@/components/auth/login.vue"),
    component: () => import("@/components/auth/login_v2.vue"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        const loggeduser = localStorage.getItem("user");
        if (loggeduser) {
          // Redirect to the home page instead
          next({
            name: "Dashboard",
          });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/register",
    name: "register",
    component: () => import("./views/account/register"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        const loggeduser = localStorage.getItem("user");
        if (loggeduser) {
          // Redirect to the home page instead
          next({
            name: "Dashboard",
          });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: () => import("@/components/auth/forgot-password.vue"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        const loggeduser = localStorage.getItem("user");
        if (loggeduser) {
          // Redirect to the home page instead
          next({
            name: "Dashboard",
          });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/privacy-noticed",
    name: "privacy-noticed",
    component: () => import("@/components/auth/privacyNoticed.vue"),
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
          store.dispatch("auth/logOut");
        } else {
          store.dispatch("authfack/logout");
        }
        const authRequiredOnPreviousRoute = routeFrom.matched.some((route) =>
          route.push("/login"),
        );
        // Navigate back to previous page, or home as a fallback
        next(
          authRequiredOnPreviousRoute
            ? {
                name: "default",
              }
            : {
                ...routeFrom,
              },
        );
      },
    },
  },

  {
    path: "/facturacion/nueva/:type",
    name: "invoice",
    component: () => import("../components/invoicing/invoice_new.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/factura/detalle/:id",
    name: "detailInvoice",
    component: () =>
      import("./../components/invoicing/sections/detail_invoice.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/detalle/factura/:id",
    name: "invoiceStampedDetail",
    component: () =>
      import("./../components/invoicing/invoice_stamped_detail.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/detalle/factura/recibida/:id",
    name: "invoiceReceivedDetail",
    component: () =>
      import("./../components/invoicing/invoice_received_detail.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/facturacion/pendientes",
    name: "pendingInvoices",
    component: () => import("./../components/invoicing/pending_invoices.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/facturacion/timbradas",
    name: "stampedInvoices",
    component: () => import("./../components/invoicing/stamped_invoices.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/facturacion/canceladas",
    name: "cancelledInvoices",
    component: () => import("./../components/invoicing/cancelled_invoices.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/facturacion/clientes",
    name: "clients",
    component: () => import("../components/clients/client.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/facturacion/clientes/nuevo",
    name: "newClient",
    component: () => import("../components/clients/client_new.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/facturacion/clientes/editar/:id",
    name: "editClient",
    component: () => import("../components/clients/client_edit.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/facturacion/configuracion/empresa",
    name: "companyConfiguration",
    component: () => import("./../components/invoicing/company.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/facturacion/configuracion/serie-folio",
    name: "companyConfigurationSeriesfolio",
    component: () => import("./../components/invoicing/series_folios.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  // {
  //   path: "/index",
  //   name: "inicio",
  //   component: () => import("../layouts/body.vue"),
  // },
  // {
  //   path: "/detalle-paquete/:id",
  //   name: "detallePaquete",
  //   component: () => import("../layouts/package-detail/detail.vue"),
  //   meta: {
  //     authRequired: true,
  //   },
  //   // beforeEnter: (to, from, next) => {
  //   //   return checkUserActivation(to, from, next);
  //   // },
  // },
  // {
  //   path: "/compra-exitosa",
  //   name: "buy success",
  //   component: () => import("../layouts/package-detail/buy.vue"),
  //   meta: {
  //     authRequired: true,
  //   },
  // },
  {
    path: "/contabilidad/facturas-recibidas",
    name: "facturas recibidas",
    component: () => import("../components/accounting/invoicesPending.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/contabilidad/complementos-de-pago",
    name: "complementos de pago",
    component: () => import("../components/accounting/paymentComplement.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/contabilidad/conciliacion",
    name: "conciliation",
    component: () => import("../components/accounting/conciliation.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/contabilidad/pagos-isr",
    name: "paymentsISR",
    component: () => import("../components/accounting/payments_isr.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/my-perfil",
    name: "myPerfil",
    component: () => import("../components/profile/my_account.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/carta-porte",
    name: "billLading",
    component: () => import("../components/billLading/bill_lading.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/carta-porte-editar/:type",
    name: "billLadingEdit",
    component: () => import("../components/billLading/bill_lading_edit.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/carta-porte/timbradas",
    name: "billLadingStamped",
    component: () =>
      import("./../components/billLading/bill_lading_stamped.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/carta-porte/operadores",
    name: "operators",
    component: () => import("../components/billLading/operator.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/carta-porte/operadores/nuevo",
    name: "operatorsNew",
    component: () => import("../components/billLading/operator_new.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/carta-porte/operadores/editar/:id",
    name: "operatorsEdit",
    component: () => import("../components/billLading/operator_edit.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/carta-porte/unidades",
    name: "units",
    component: () => import("../components/billLading/unit.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/carta-porte/unidades/nueva",
    name: "unitsNew",
    component: () => import("../components/billLading/unit_new.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/carta-porte/unidades/editar/:id",
    name: "unitsEdit",
    component: () => import("../components/billLading/unit_edit.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/carta-porte/ubicaciones",
    name: "ubications",
    component: () => import("../components/billLading/ubication.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/carta-porte/ubicaciones/nueva",
    name: "ubicationsNew",
    component: () => import("../components/billLading/ubication_new.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/carta-porte/ubicaciones/editar/:id",
    name: "ubicationsEdit",
    component: () => import("../components/billLading/ubication_edit.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  // RUTAS PANEL DOS
  {
    path: "/clientes",
    name: "clients",
    component: () => import("../components/clients/client.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/clientes/nuevo",
    name: "clientsNew",
    component: () => import("../components/clients/client_new.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/legal/terminos-condiciones",
    name: "termConditions",
    component: () => import("../components/legal/terms_conditions.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/legal/politicas-privacidad",
    name: "politicasPrivacidad",
    component: () => import("../components/legal/privacy_policies.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/preguntas-frecuentes",
    name: "faq",
    component: () => import("../components/faq/faq.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/preguntas-frecuentes/nueva",
    name: "faqNew",
    component: () => import("../components/faq/faq_new.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/preguntas-frecuentes/editar/:id",
    name: "faqEdit",
    component: () => import("../components/faq/faq_edit.vue"),
    meta: {
      authRequired: true,
    },
  },

  // Paquetes
  {
    path: "/paquetes",
    name: "paquetes",
    component: () => import("../components/package/admin/index.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/paquetes/nuevo",
    name: "paquetesNuevo",
    component: () => import("../components/package/admin/new.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/paquetes/edit/:id",
    name: "paquetesEdit",
    component: () => import("../components/package/admin/new.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/beneficios",
    name: "beneficios",
    component: () => import("../components/package/admin/benefits/index.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/beneficios/:id",
    name: "beneficiosEdit",
    component: () => import("../components/package/admin/benefits/edit.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/crear-complemento-de-pago",
    name: "ComplementoDePago",
    component: () =>
      import("../components/payment_complement/payment_index.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/complemento-de-pago/nuevo/:id",
    name: "newComplementoDePago",
    component: () => import("../components/payment_complement/new_payment.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/complemento-de-pago-pendientes",
    name: "PendingComplementoDePago",
    component: () =>
      import("../components/payment_complement/pending_payment.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/complemento-de-pago-timbradas",
    name: "StampedComplementoDePago",
    component: () =>
      import("../components/payment_complement/stamped_payment.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/detalle/complemento/:id",
    name: "paymentStampedDetail",
    component: () =>
      import("./../components/payment_complement/payment_stamped_detail.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/facturas-de-retencion-recibidas",
    name: "InvoicesWithholdingReceived",
    component: () => import("../components/invoices_withholding/received.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/complemento-de-pago-canceladas",
    name: "cancelComplementoDePago",
    component: () =>
      import("../components/payment_complement/cancel_payment.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/complemento-de-pago/bancos",
    name: "banks",
    component: () => import("../components/payment_complement/bank/bank.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/complemento-de-pago/banco/nuevo",
    name: "newBank",
    component: () =>
      import("../components/payment_complement/bank/bank_new.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/complemento-de-pago/banco/editar/:id",
    name: "editBank",
    component: () =>
      import("../components/payment_complement/bank/bank_edit.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  // Cuentas
  {
    path: "/facturas/pagar",
    name: "cuentaspagar",
    component: () => import("../components/accounts/payable/index_new.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/cuentas/pagar/index",
    name: "cuentaspagarlist",
    component: () => import("../components/accounts/payable/list.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/cuentas/cobrar",
    name: "cuentascobrar",
    component: () => import("../components/accounts/receivable/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/cuentas/cobrar/:cliente_id",
    name: "cuentascobrarstatement",
    component: () => import("../components/accounts/receivable/statement.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/cuentas/cobrar/historico/:id",
    name: "cuentascobrarstatementhistorical",
    component: () => import("../components/accounts/receivable/historical.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/cuentas/cobrar/aplicar_pago/:id",
    name: "cuentascobrarstatementpay",
    component: () => import("../components/accounts/receivable/pay.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/cuentas/cobrar/aplicar_pago/multiple",
    name: "cuentascobrarstatementpaymultiple",
    component: () =>
      import("../components/accounts/receivable/payMultiple.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/calcular/index",
    name: "CalcularPagoIsr",
    component: () => import("../components/calculation/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/banca",
    name: "paybook",
    component: () => import("../components/paybook/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/banca-widget",
    name: "paybookWidget",
    component: () => import("../components/paybook/widget.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/advertencias-banca",
    name: "warningPaybook",
    component: () => import("../components/paybookLogs/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },

  //Banners inicio
  {
    path: "/secciones",
    name: "secciones",
    component: () =>
      import("../components/banners/front-page/secciones/secciones.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/secciones/:tipo",
    name: "seccionesTipo",
    component: () =>
      import("../components/banners/front-page/secciones/index.vue"),
    meta: {
      authRequired: true,
    },
  },

  {
    path: "/secciones/nuevo/:tipo",
    name: "seccionesNew",
    component: () =>
      import("../components/banners/front-page/secciones/new.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/secciones/editar/:id",
    name: "seccionesEdit",
    component: () =>
      import("../components/banners/front-page/secciones/edit.vue"),
    meta: {
      authRequired: true,
    },
  },

  {
    path: "/banner-portada",
    name: "BannerPortada",
    component: () => import("../components/banners/front-page/index.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/banner-portada-nuevo",
    name: "BannerPortadaNew",
    component: () => import("../components/banners/front-page/new.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/banner-portada-editar/:id",
    name: "BannerPortadaEdit",
    component: () => import("../components/banners/front-page/edit.vue"),
    meta: {
      authRequired: true,
    },
  },
  //Banners clientes
  {
    path: "/banner-cliente",
    name: "BannerCliente",
    component: () => import("../components/banners/customers/index.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/banner-cliente-nuevo",
    name: "BannerClienteNew",
    component: () => import("../components/banners/customers/new.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/banner-cliente-editar/:id",
    name: "BannerClienteEdit",
    component: () => import("../components/banners/customers/edit.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/mensaje-contacto/nuevo",
    name: "ContactMessageNew",
    component: () => import("../components/contact_messages/new.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/mensaje-contacto",
    name: "ContactMessage",
    component: () => import("../components/contact_messages/index.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/mensaje-contacto/informacion/:id",
    name: "ContactMessageInfo",
    component: () => import("../components/contact_messages/info.vue"),
    meta: {
      authRequired: true,
    },
  },

  //conciliación
  {
    path: "/conciliacion-facturas-emitidas",
    name: "ConciliacionIndex",
    component: () => import("../components/conciliation/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/conciliacion/registrar-pago/:id",
    name: "ConciliacionRegisterPay",
    component: () => import("../components/conciliation/register_pay.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/conciliacion/historico-pago/:id",
    name: "ConciliacionHistoricPay",
    component: () => import("../components/conciliation/history_pay.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  //conciliación manual
  {
    path: "/conciliacion-manual",
    name: "ConciliacionIndexManual",
    component: () => import("../components/conciliation/index-manual.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  //conciliación manual
  {
    path: "/conciliacion-bancos",
    name: "ConciliacionBanckIndex",
    component: () => import("../components/conciliation/bank/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  // Conciliación por facturas recibidadas
  {
    path: "/conciliacion-facturas-recibidas",
    name: "ConciliacionRecibidasIndex",
    component: () =>
      import("../components/conciliation/invoices_received/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },

  {
    path: "/conciliacion-facturas-recibidas/registrar-pago/:id",
    name: "ConciliacionRecibidasRegisterPay",
    component: () =>
      import("../components/conciliation/invoices_received/register_pay.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/conciliacion-facturas-recibidas/historico-pago/:id",
    name: "ConciliacionRecibidasHistoricPay",
    component: () =>
      import("../components/conciliation/invoices_received/history_pay.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/conciliacion-lista-transacciones/:id",
    name: "ConciliacionManualListTransaction",
    component: () =>
      import("../components/conciliation/sections/bank-transaction.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  //Deducciones
  {
    path: "/deducciones/index",
    name: "DeduccionesIndex",
    component: () => import("../components/deduction/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  // TIEMPO TRASCURRIDO PARA SERVICIO DE EFISCO
  {
    path: "/efisco/index",
    name: "MessageDateEfisco",
    component: () => import("../components/messageEfisco/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/facturacion/alertas/:id",
    name: "warningInvoice",
    component: () => import("../components/invoicing/warning/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/facturas/canceladas",
    name: "invoicesCancel",
    component: () => import("../components/accounts/cancel/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/facturacion/productos-servicios",
    name: "productsServices",
    component: () => import("../components/productsServices/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/facturacion/productos-servicios/nuevo",
    name: "productsServicesNew",
    component: () => import("../components/productsServices/new.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/facturacion/productos-servicios/editar/:id",
    name: "productsServicesedit",
    component: () => import("../components/productsServices/edit.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/mi-plan",
    name: "myPlan",
    component: () => import("../components/profile/myPlan/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/mis-tarjetas",
    name: "myCards",
    component: () => import("../components/profile/myCards/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/mi-empresa",
    name: "myCompany",
    component: () => import("../components/myCompany/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/clientes-suscritos",
    name: "SubscribedCustomersIndex",
    component: () => import("../components/subscribedCustomers/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/clientes-suscritos/editar/:id",
    name: "SubscribedCustomersEdit",
    component: () => import("../components/subscribedCustomers/edit.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/clientes-suscritos/historial/:id",
    name: "SubscribedCustomersHistory",
    component: () => import("../components/subscribedCustomers/history.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/advertencias-efisco",
    name: "warningEfisco",
    component: () => import("../components/EfiscoLogs/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/renovar-plan",
    name: "renovationPlan",
    component: () => import("../components/profile/renovation/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/renovar-plan/:id",
    name: "renovationPlanShow",
    component: () => import("../components/profile/renovation/show.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/paquetes-sync-paybook",
    name: "paquetesSyncPaybook",
    component: () => import("../components/packageSyncPaybook/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/paquetes-facturacion",
    name: "paquetesFacturacion",
    component: () => import("../components/packageFacturacion/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/cupones",
    name: "cuponesPaquetes",
    component: () => import("../components/coupons/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/cupones/nuevo",
    name: "couponsPackagesNuevo",
    component: () => import("../components/coupons/new.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/cupones/editar/:id",
    name: "couponsPackagesEdit",
    component: () => import("../components/coupons/edit.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/usuarios",
    name: "UsersIndex",
    component: () => import("../components/admin/users/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/usuarios/nuevo",
    name: "UsersCreate",
    component: () => import("../components/admin/users/new.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/usuarios/editar/:id",
    name: "UsersEdit",
    component: () => import("../components/admin/users/edit.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/roles",
    name: "RolesIndex",
    component: () => import("../components/admin/roles/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/roles/nuevo",
    name: "RolesCreate",
    component: () => import("../components/admin/roles/new.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/roles/editar/:id",
    name: "RolesEdit",
    component: () => import("../components/admin/roles/edit.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/menu/:id/package/:packageId?",
    name: "MenuIndex",
    component: () => import("../components/admin/menu/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/menu/:id/packages",
    name: "MenuIndex",
    component: () => import("../components/admin/menu/packages.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/reporte-mensual",
    name: "ReportMonth",
    component: () => import("../components/reports/index_month.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/reporte-anual",
    name: "ReportYear",
    component: () => import("../components/reports/index_year.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/facturas-recurrentes",
    name: "RecurringInvoices",
    component: () => import("../components/recurringInvoice/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/dashboard/index",
    name: "DashboardGeneral",
    component: () => import("../components/DashboardGeneral/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/my-perfil/usuarios",
    name: "UsersProfileIndex",
    component: () => import("../components/profile/users/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/my-perfil/usuarios/nuevo",
    name: "UsersProfileCreate",
    component: () => import("../components/profile/users/new.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/my-perfil/usuarios/editar/:id",
    name: "UsersProfileEdit",
    component: () => import("../components/profile/users/edit.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "*", // Captura cualquier ruta no definida
    redirect: { name: "login" }, // Redirige al login
  },
  {
    path: "/configuracion-inicial",
    name: "settingCompanyIndex",
    component: () => import("../components/settingsCompany/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/comprar-paquetes",
    name: "payPackagesIndex",
    component: () => import("../components/profile/payPackage/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/declaraciones",
    name: "declarationsIndex",
    component: () => import("../components/taxDeclaration/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/contadores",
    name: "accountantIndex",
    component: () => import("../components/accountant/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/contadores/perfil/:id",
    name: "accountantPerfil",
    component: () => import("../components/accountant/perfil.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/contadores/buscar",
    name: "accountantBuscar",
    component: () => import("../components/accountant/search/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/contadores/perfil-suscriptores/:id",
    name: "accountantSuscribers",
    component: () => import("../components/accountant/suscribers.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/contadores/documentos",
    name: "accountantDocuments",
    component: () => import("../components/accountant/documents/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/contadores/variables",
    name: "accountantVariables",
    component: () => import("../components/accountant/variables/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/contadores-dashboard",
    name: "DashboardAccountant",
    component: () => import("./../components/accountant/dashboard/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      console.log(from);
      if (from.name === "login") {
        // Asume que tu ruta de login se llama 'Login'
        to.meta.fromLogin = true;
      }
      next();
    },
  },
  {
    path: "/contadores/configuracion-inicial",
    name: "settingAccountant",
    component: () =>
      import("./../components/accountant/settingsAccountant/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/contadores/contratos",
    name: "contactAccountant",
    component: () =>
      import("./../components/accountant/settingsAccountant/contract.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/contadores/mi-perfil",
    name: "myPerfilAccountant",
    component: () =>
      import("./../components/accountant/settingsAccountant/myPerfil.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/contadores/mi-buzon",
    name: "myMailBoxAccountant",
    component: () => import("./../components/accountant/myMailBox/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/admin/contadores/solicitudes-cotizacion/:id_suscriber/:id_accountant",
    name: "myMailBoxAccountantAdmin",
    component: () =>
      import("./../components/accountant/admin/myMailBox/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/contadores/bancos",
    name: "banksAccountant",
    component: () => import("./../components/accountant/banks/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "*", // Captura cualquier ruta no definida
    redirect: { name: "login" }, // Redirige al login
  },
  {
    path: "/contadores/suscriptor/buzon",
    name: "suscriberMailBoxAccountant",
    component: () =>
      import("./../components/accountant/MailBoxSuscriber/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/contadores/suscriptor/buzon/detalle-cotizacion/:id",
    name: "suscriberMailBoxDetailAccountant",
    component: () =>
      import("./../components/accountant/MailBoxSuscriber/detailQuote.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/contadores/suscriptor/buzon/detalle-termino-pago/:id",
    name: "suscriberMailBoxDetailTermPayAccountant",
    component: () =>
      import("./../components/accountant/MailBoxSuscriber/detailTermPay.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/contadores/chat/:id",
    name: "chatAccountant",
    component: () => import("./../components/accountant/chat/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/contadores/mis-suscritos",
    name: "mySuscribersAccountant",
    component: () =>
      import("./../components/accountant/mySuscribers/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/contadores/mi_contador",
    name: "myAccountant",
    component: () =>
      import("./../components/accountant/my_accountant/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/contadores/mi_contador/voucher/:id",
    name: "AccountatVoucher",
    component: () => import("./../components/accountant/voucher/index.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  {
    path: "/contadores/terminos-condiciones",
    name: "termConditions",
    component: () =>
      import("../components/accountant/legal/terms_conditions.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/contadores/politicas-privacidad",
    name: "politicasPrivacidad",
    component: () =>
      import("../components/accountant/legal/privacy_policies.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/contadores/mis-facturas",
    name: "accountantMyInvoices",
    component: () => import("../components/accountant/invoices/index.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/contadores/:id_contract/:id_document/:id_widget",
    name: "accountantFirma",
    component: () => import("../components/accountant/documents/firma.vue"),
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      return checkUserActivation(to, from, next);
    },
  },
  // Blindaje Fiscal
  {
    path: "/blindaje-fiscal/proveedores",
    name: "taxShieldSuppliers",
    component: () => import("../components/taxShield/Suppliers/supplierIndex.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/blindaje-fiscal/proveedores/registro/:id",
    name: "taxShieldSuppliersRegister",
    component: () => import("../components/taxShield/Suppliers/supplierRegister.vue"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        const loggeduser = localStorage.getItem("user");
        if (loggeduser) {
          // Redirect to the home page instead
          next({
            name: "Dashboard",
          });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/blindaje-fiscal/facturas-emitidas",
    name: "taxShieldIssuedInvoices",
    component: () => import("../components/taxShield/InvoicesIssued/invoiceIssuedIndex.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/blindaje-fiscal/facturas-emitidas/materialidad/:id",
    name: "taxShieldIssuedInvoicesMateriality",
    component: () => import("../components/taxShield/InvoicesIssued/materialityFile.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/blindaje-fiscal/facturas-recibidas",
    name: "taxShieldReceivedInvoices",
    component: () => import("../components/taxShield/InvoicesReceived/invoiceReceivedIndex.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/blindaje-fiscal/facturas-recibidas/materialidad/:id",
    name: "taxShieldReceivedInvoicesMateriality",
    component: () => import("../components/taxShield/InvoicesReceived/materialityFile.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/blindaje-fiscal/proveedor/facturas",
    name: "taxShieldSupplerInvoices",
    component: () => import("../components/taxShield/Suppliers/Invoices/InvoicesIndex.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/blindaje-fiscal/proveedor/facturas/materialidad/:id",
    name: "taxShieldSupplerInvoicesMateriality",
    component: () => import("../components/taxShield/Suppliers/Invoices/materialityFile.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "*", // Captura cualquier ruta no definida
    redirect: { name: "login" }, // Redirige al login
  },
];

function checkUserActivation(to, from, next) {
  console.log("TO", to);
  console.log("FROM", from);
  console.log("NEXT", next);
  const data = localStorage.getItem("user");
  const user = JSON.parse(data);

  // Validar usuario admin
  if (user.role == "Contador") {
    const accountant_data = localStorage.getItem("accountant");
    const accountant = JSON.parse(accountant_data);


    if (accountant.status != 1) { // Activo

      if(to.name === "DashboardAccountant" || to.name === "settingAccountant" || to.name === "myPerfilAccountant") {
        next();
        return;
      }else{
        next({ name: "DashboardAccountant" });
        return;
      }
    }
  }

  // Validar usuario admin
  if (user.role != "Client") {
    next();

    return;
  }

  // Rutas si el usuario esta activo y paquete vencido
  const menusProfile = [
    "mi-plan",
    "my-perfil",
    "mis-tarjetas",
    "advertencias-banca",
    "advertencias-efisco",
    "renovar-plan",
  ];
  const validationProfile = [];

  // Rutas si el usuario esta desactivado y el paquete ya no tiene vigencia
  const menusUserActivePackageInactivate = [
    "mi-plan",
    "mis-tarjetas",
    "renovar-plan",
  ];
  const validationUserActivePackageInactivate = [];
  // Rutas si el usuario esta desactivado y el paquete tiene vigencia activa

  // Validar si el usuario esta activo y paquete vencido
  if (user.is_active == 1 && user.package_validate.validate == false) {
    console.log("ACTIVE - VALIDATE FALSE");
    menusProfile.forEach((item) => {
      const validateMiPlan = to.path.includes(item) ? true : false;
      validationProfile.push(validateMiPlan);
    });
    const isValidationFilter = validationProfile.filter((item) => item == true);
    if (isValidationFilter.length == 0) {
      next({ name: "myPlan" });
    } else {
      next();
    }
  } else if (user.is_active == 0 && user.package_validate.validate == true) {
    console.log("ACTIVE - VALIDATE TRUE");
    next({ name: "DeactivateUser" });
  } else if (user.is_active == 0 && user.package_validate.validate == false) {
    console.log("DESACTIVATE - VALIDATE FALSE");
    menusUserActivePackageInactivate.forEach((item) => {
      const validateMiPlan = to.path.includes(item) ? true : false;
      validationUserActivePackageInactivate.push(validateMiPlan);
    });
    console.log(
      "validationUserActivePackageInactivate",
      validationUserActivePackageInactivate
    );
    const isValidationFilter = validationUserActivePackageInactivate.filter(
      (item) => item == true
    );
    if (isValidationFilter.length == 0) {
      next({ name: "DeactivateUser" });
    } else {
      next();
    }
  } else {
    next();
  }
}














